module.exports = __webpack_public_path__ + "static/media/brick-s-10.20964ecf.png";